import React from 'react';
import { useNavigate } from 'react-router-dom';
import tw from 'twin.macro';

import { BigTitle, Caption } from '@/components';

function LandingPrepaidConditions({ setOpen }) {
  const navigate = useNavigate();
  const handleNavigateToSteps = () => {
    navigate('/deposit-card/apply');
  };

  const location = window.location.host;

  return (
    <div tw='sm:py-10 py-14 bg-secondary sm:px-5'>
      <div tw='max-w-app mx-auto'>
        <BigTitle text={'Условия и тарифы'} twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`} />

        <table tw='min-w-full divide-y divide-grey my-10'>
          <tbody tw='divide-y divide-grey '>
            <tr>
              <td tw='p-5 bg-[#444444] rounded-t-2xl align-top '>Вид карты</td>
              <td tw='font-bold p-5'>
                Mastercard Prepaid
                <br />
                <Caption text={<span>цифровая</span>} twStyle={tw`text-secondary`} />
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Выпуск</td>
              <td tw='font-bold p-5 flex sm:flex-row flex-col gap-5'>
                <div>
                  50 $ на карту
                  <Caption text={<span>+ 3 000 ₸</span>} twStyle={tw`text-secondary`} />
                </div>
                <div>
                  100 $ на карту
                  <Caption text={<span>+ 5 000 ₸</span>} twStyle={tw`text-secondary`} />
                </div>
                <div>
                  200 $ на карту
                  <Caption text={<span>+ 7 000 ₸</span>} twStyle={tw`text-secondary`} />
                </div>
                <div>
                  300 $ на карту
                  <Caption text={<span>+ 9 000 ₸</span>} twStyle={tw`text-secondary`} />
                </div>
                <div>
                  400 $ на карту
                  <Caption text={<span>+ 11 000 ₸</span>} twStyle={tw`text-secondary`} />
                </div>
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top '>Валюта </td>
              <td tw='font-bold p-5'>доллары</td>
            </tr>

            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Срок действия</td>
              <td tw='font-bold p-5'>
                6 месяцев с момента выпуска
                <Caption
                  text={<span>Карта закроется автоматически, когда закончится срок действия или деньги на карте</span>}
                  twStyle={tw`text-secondary`}
                />
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Оплаты в торговых точках и интернете</td>
              <td tw='font-bold p-5'>без комиссии</td>
            </tr>
            <tr tw=''>
              <td tw='p-5 bg-[#444444] align-top'>Переводы на карты других банков</td>
              <td tw='font-bold p-5'>
                {/* 1%
                <Caption text={<span>минимум 250 тенге</span>} twStyle={tw`text-secondary`} /> */}
                нет
              </td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444] align-top'>Пополнения</td>
              <td tw='font-bold p-5'>нет</td>
            </tr>
            <tr>
              <td tw='p-5 bg-[#444444]  rounded-b-2xl align-top'>Снятие наличных</td>
              <td tw='font-bold p-5'>нет</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LandingPrepaidConditions;
